export default [
  {
    path: "/welcome",
    name: "ViewWelcomeLanding",
    meta: { name: "Ваш путь", role: 'no' },
    component: () => import("@/views/viewWelcome/ViewWelcomeLanding.vue"),
  }
]